module.exports = __webpack_public_path__ + "img/Button_Spin.12089aa6.png";